const $ = window.jQuery


export const init = () => {
  $(document).on('click', '.js-sb-largeLink', function (e) {
    const $target = $(e.target)
    if (
      e.target.closest('.js-sb-largeLink-ignore') !== null ||
      e.target.closest('.contextual-links') !== null ||
      $target.is('.contextual button')
    ) {
      return true;
    }
    e.preventDefault()
    window.location = this.dataset.url
  })
}



//////////////////
// WEBPACK FOOTER
// ./src/js/sb/largeLinks.js
// module id = 11
// module chunks = 0